import React, { useState } from 'react';
import { dynamoDb } from '../../awsConfig';
import './OldVideoHub.css';

const OldVideoHub = () => {
  const [dateFilter, setDateFilter] = useState('');
  const [videos, setVideos] = useState([]);

  const fetchVideos = async () => {
    if (!dateFilter) {
      alert('Please select a date to fetch videos.');
      return;
    }

    try {
      const result = await dynamoDb
        .query({
          TableName: 'videos2',
          KeyConditionExpression: '#Date = :dateValue',
          ExpressionAttributeNames: {
            '#Date': 'Date',
          },
          ExpressionAttributeValues: {
            ':dateValue': dateFilter,
          },
        })
        .promise();

      setVideos(result.Items || []);
    } catch (error) {
      console.error('Error fetching videos:', error);
      alert('Error fetching videos. Please try again.');
    }
  };

  return (
    <div className="video-list">
      <h2>Video Lectures</h2>
      <label>
        Select Date: 
        <input
          type="date"
          value={dateFilter}
          onChange={(e) => setDateFilter(e.target.value)}
        />
      </label>
      <button onClick={fetchVideos}>Fetch Videos</button>
      <div className="videos-container">
        {videos.map((video) => (
          <div key={`${video.Date}-${video.Subject}`} className="video-item">
            <h3>
              Date: {video.Date}, Subject: {video.Subject}
            </h3>
            <a href={video.videoUrl} target="_blank" rel="noopener noreferrer">
              Watch Video
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OldVideoHub;